import { AuthGuard } from "@app/common/auth.guard";
import { SearchComponent } from "./component";

export const SearchRoute = {
  path: "search/:query_string",
  component: SearchComponent,
  canActivate: [AuthGuard],
};
